import { A } from 'vitest/dist/chunks/environment.LoooBwUu.js';
import { apiClient } from './apiClient';

// export interface SectionItem {
//   priority?: number;
//   taskName?: string;
//   task?: string;
//   startDate?: string;
//   endDate?: string;
//   taskDescription?: string;
// }

// export interface SourceInfo {
//   staffName?: string;
//   clientName?: string;
//   auditDateRange?: string;
//   documentTabOverview?: string | null;
// }

export interface RenewalTask {
  id: string;
  taskKey: string;
  tenantId: string;
  clientId: string;
  clientName: string;
  itemId: string;
  itemCode: string;
  itemName: string;
  sectionName: string;
  status: 'OPEN' | 'IN_PROGRESS' | 'WAITING' | 'RESOLVED' | 'CLOSED';
  bucket: 'OVERDUE' | 'D0_3' | 'D4_7' | 'D8_14' | 'D15_30' | 'D31_90' | 'D90_PLUS';
  priority: 'P0' | 'P1' | 'P2' | 'P3' | 'P4';
  ownerRole: string;
  ownerUserId?: string;
  ownerEmailHint?: string;
  owner?: {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
  };
  dueDate?: string;
  startDate?: string;
  endDate?: string;
  reason: string;
  evidence?: Array<{
    type: string;
    uri: string;
    label: string;
  }>;
  documents?: Array<{
    id?: string;
    type: string;
    section?: string;
    startDate?: string;
    endDate?: string;
    required?: boolean;
    status: 'PENDING' | 'VALID' | 'EXPIRED';
    fileName?: string;
    fileUrl?: string;
    uploadedBy?: string;
    uploadedAt?: string;
    reviewedBy?: string;
    reviewedAt?: string;
    comment?: string;
    history?: Array<{
      at: string;
      by: string;
      action: 'UPLOADED' | 'APPROVED' | 'REJECTED' | 'COMMENTED';
      notes?: string;
    }>;
  }>;
  source?: {
    // info?: SourceInfo;
    filePath: string;
    rowNumber?: number;
    sections?: any;
  };
  auditTrail?: Array<{
    at: string;
    by: string;
    action: string;
    details: any;
  }>;
  createdAt: string;
  updatedAt: string;
}

export interface RenewalTasksResponse {
  success: boolean;
  data: {
    tasks: RenewalTask[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalCount: number;
      hasNext: boolean;
      hasPrev: boolean;
      limit: number;
    };
  };
}

export interface ClientDetailsResponse {
  success: boolean;
  data: {
    clientId: string;
    clientName: string;
    totalTasks: number;
    tasksByStatus: {
      OPEN: RenewalTask[];
      IN_PROGRESS: RenewalTask[];
      WAITING: RenewalTask[];
      RESOLVED: RenewalTask[];
      CLOSED: RenewalTask[];
    };
    allTasks: RenewalTask[];
  };
}

export interface UpdateTaskStatusRequest {
  status: 'OPEN' | 'IN_PROGRESS' | 'WAITING' | 'RESOLVED' | 'CLOSED';
  details?: Record<string, any>;
}

export interface RenewalTaskFilters {
  ownerUserId?: string;
  range?: 'day' | 'week' | 'month' | 'quarter';
  priority?: 'P0' | 'P1' | 'P2' | 'P3' | 'P4';
  status?: 'OPEN' | 'IN_PROGRESS' | 'WAITING' | 'RESOLVED' | 'CLOSED';
  bucket?: 'OVERDUE' | 'D0_3' | 'D4_7' | 'D8_14' | 'D15_30' | 'D31_90' | 'D90_PLUS';
  clientId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

/**
 * Get renewal tasks with filters
 */
export const getRenewalTasks = async (
  filters: RenewalTaskFilters,
  token: string
): Promise<RenewalTasksResponse> => {
  const queryParams: Record<string, string> = {};

  // if (filters.ownerUserId) queryParams.ownerUserId = filters.ownerUserId;
  if (filters.range) queryParams.range = filters.range;
  if (filters.priority) queryParams.priority = filters.priority;
  if (filters.status) queryParams.status = filters.status;
  if (filters.bucket) queryParams.bucket = filters.bucket;
  if (filters.clientId) queryParams.clientId = filters.clientId;
  if (filters.search) queryParams.search = filters.search;
  if (filters.page) queryParams.page = String(filters.page);
  if (filters.limit) queryParams.limit = String(filters.limit);

  const response = await apiClient('renewal-tasks', {
    method: 'GET',
    token,
    queryParams,
  });

  return response.json();
};

/**
 * Get client details with all tasks
 */
export const getClientDetails = async (
  clientId: string,
  token: string
): Promise<ClientDetailsResponse> => {
  const response = await apiClient(`renewal-tasks/clients/${clientId}`, {
    method: 'GET',
    token,
  });

  return response.json();
};

/**
 * Update task status
 */
export const updateTaskStatus = async (
  taskId: string,
  request: UpdateTaskStatusRequest,
  token: string
): Promise<{ success: boolean; data: { task: RenewalTask } }> => {
  const response = await apiClient(`renewal-tasks/${taskId}`, {
    method: 'PATCH',
    token,
    body: request,
  });

  return response.json();
};

